import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { AuthenticationService } from '@insight-services/authentication.service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'ngx-otp-dialog',
  templateUrl: './otp-dialog.component.html',
  styleUrls: ['./otp-dialog.component.scss']
})
export class OtpDialogComponent implements OnInit, OnDestroy {
  otpForm: FormGroup;
  remainingTime: number = 120; 
  showResendButton: boolean = false;
  private timerSubscription: Subscription;
  @Input() email: string ;

  constructor(
    protected dialogRef: NbDialogRef<OtpDialogComponent>,
    private fb: FormBuilder,
    private toastrService: NbToastrService,
    protected authService: AuthenticationService   
  ) {
    this.otpForm = this.fb.group({
      otp: this.fb.array(Array(6).fill('').map(() => this.fb.control('', [Validators.required, Validators.pattern('^[0-9]*$')])))
    });
  }

  ngOnInit() {
    this.startTimer();
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  get otpControls() {
    return this.otpForm.get('otp') as FormArray;
  }

  confirmOtp() {
    if (this.otpForm.valid) {
      const otp = this.otpControls.value.join('');
      this.dialogRef.close(otp);
    } else {
      this.toastrService.danger('Please enter a valid OTP', 'Invalid OTP');
    }
  }

  moveFocus(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (input.value.length === 1 && index < 5) {
      const nextInput = document.getElementById('otp' + (index + 1));
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  private startTimer() {
    this.timerSubscription = interval(1000).subscribe(() => {
      if (this.remainingTime > 0) {
        this.remainingTime--;
      } else {
        this.timerSubscription.unsubscribe();
        this.showResendButton = true;
        this.toastrService.warning('OTP has expired', 'Expired');
      }
    });
  }

  resendOtp() {
    this.remainingTime = 120; 
    this.showResendButton = false;
    this.startTimer();
    this.toastrService.success('OTP has been resent', 'Resent');
    this.authService.emailVerification(this.email).subscribe(res => {
      if (res.message === "success") {
        this.toastrService.success("Email verification code sent to your email address.", "Success");
      }
    });
  }

  handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    if (!clipboardData) return;

    const pastedText = clipboardData.getData('text').replace(/\D/g, '');
    
    if (pastedText.length === 0) return;

    const otpArray = this.otpForm.get('otp') as FormArray;
    
    [...pastedText].slice(0, otpArray.length).forEach((char, index) => {
      otpArray.at(index).setValue(char);
    });

    const lastFilledIndex = Math.min(pastedText.length - 1, otpArray.length - 1);
    const lastInput = document.getElementById(`otp${lastFilledIndex}`);
    lastInput?.focus();
  }
}